import { FC } from 'react';
import classNames from 'classnames';
import Button from 'src/Components/Button';
import { IFilterProps } from '.';
import { ReactComponent as DateIcon } from "../../assets/calendar.svg";
import { CalendarWidget } from 'src/UI';
import DateFormater from 'src/Utils/DateFormater';
import st from "./DefFilterCommon.module.scss";

/** Компонента фильтра по дате */
const Date: FC<IFilterProps> = ( props ) => {

	const { columnId, isShowModal, 
		value, setValue,
		cancelHandler, applyValueHandler 
	} = props;

	/** Подготовка массива дат для виджета */
	const prepareValuesForWidget = () => {
		const vals: Array<Date|null> = [];
		if ( !!value && Array.isArray(value) && !!value.length ) {
			value.forEach( date => {
				if ( !!date && typeof date === "string" )
					vals.push( DateFormater.getDate( date ) );
				else
					vals.push( date );
			});
		}
		return vals;
	};

	/** Подготовка строки для инпута таблицы */
	const prepareValuesForInput = () => {
		const vals: Array<string> = [];
		if ( !!value && Array.isArray(value) && !!value.length ) {
			value.forEach( date => {
				if ( !!date && typeof date === "string" )
					vals.push( DateFormater.toShortString( date ) );
				else 
					vals.push('');
			});
			return vals.length > 1 ? vals.join( " - ") : vals[0];
		}
		return "";
	};

	/** Рендер кнопок отмена/применить */
	const renderButtons = () => (
		<div className={st.modalButtons}>
			<Button id={'filter_cancel-' + columnId} onClick={cancelHandler} variant='red' outline>Отмена</Button>
			<Button id={'filter_apply-' + columnId} onClick={applyValueHandler}>Применить</Button>
		</div>
	);

	const textValue = prepareValuesForInput();
	return (
		<>
			<DateIcon />
			<input className='body-small' readOnly value={textValue} data-tooltip-id="rdc_tooltip" data-tooltip-content={textValue} />
			{
				isShowModal &&
				<div className={classNames(st.modalBody, st.calendar)}>
					<CalendarWidget
						selectType="between"
						values={prepareValuesForWidget()}
						renderBottomToolbar={renderButtons}
						onValuesChange={setValue}
					/>
				</div>
			}
		</>
	);
};

export default Date;
